import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';

import cx from 'clsx';
// import _set from 'lodash/set';

const styles = theme => ({
    root: {
        textTransform: 'none',
        cursor: 'pointer',
    },
    bold: {
        fontWeight: 500,
    },
});

const AfitdLink = props => {
    const { classes, className: classNameProp, isHidden, label, children, bold = true, ...otherProps } = props;

    const className = cx(classes.root, { [classes.bold]: bold }, classNameProp);

    if (isHidden) {
        return null;
    } else {
        return (
            <Link className={className} {...otherProps}>
                {label || children}
            </Link>
        );
    }
};

export default withStyles(styles)(AfitdLink);
